const state = {
	addPermission: false,
	adminPermission: false,
	editPermission: false,
	uploadPermission: false,
	successfulPermission: false,
	cronPermission: false,
	userEmail: '',
}
const mutations = {
	SET_ADD_PERMISSION: (state, payload) => {
		state.addPermission = payload;

	},
	SET_ADMIN_PERMISSION: (state, payload) => {
		state.adminPermission = payload;

	},
	SET_EDIT_PERMISSION: (state, payload) => {
		state.editPermission = payload;

	},
	SET_UPLOAD_PERMISSION: (state, payload) => {
		state.uploadPermission = payload;

	},
	SET_SUCCESSFUL_PERMISSION: (state, payload) => {
		state.successfulPermission = payload;

	},
	SET_CRON_PERMISSION: (state, payload) => {
		state.successfulPermission = payload;

	},
	SET_USER_EMAIL: (state, payload) => {
		state.userEmail = payload
	}

}

const actions = {
	setAddPermission({ commit }, payload) {
		commit('SET_ADD_PERMISSION', payload)
	},
	setAdminPermission({ commit }, payload) {
		commit('SET_ADMIN_PERMISSION', payload);
	},
	setEditPermission({ commit }, payload) {
		commit('SET_EDIT_PERMISSION', payload);
	},
	setUploadPermission({ commit }, payload) {
		commit('SET_UPLOAD_PERMISSION', payload);
	},
	setSuccessfulPermission({ commit }, payload) {
		commit('SET_SUCCESSFUL_PERMISSION', payload);
	},
	setCronPermission({ commit }, payload) {
		commit('SET_CRON_PERMISSION', payload);
	},
	setUserEmail({ commit }, payload) {
		commit('SET_USER_EMAIL', payload);
	}
}

const getters = {
	addPermission: state => state.addPermission,
	adminPermission: state => state.adminPermission,
	editPermission: state => state.editPermission,
	uploadPermission: state => state.uploadPermission,
	successfulPermission: state => state.successfulPermission,
	userEmail: state => state.userEmail
}

export default {
	state,
	mutations,
	actions,
	getters
}


// WEBPACK FOOTER //
// ./src/store/module/permissions.js